import { useContext } from "react";
import { DrawerContext, AuthContext } from "@CONTEXTS";
import { Button, Tooltip, Menu, Dropdown, Tag, Modal, message } from "antd";
import { CopyElement } from "@UI";
import { moment } from "@LIBS";
import { Constants } from "@CONFIG";
import { AiFillDelete, AiOutlineBarcode, AiOutlineDown } from "react-icons/ai";
import { TbTruckReturn, TbPackageImport } from "react-icons/tb";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  deleteDeliveryInOperation,
  recallDeliveryInOperation,
} from "@DELIVERIES";
import { useAuthority } from "@HOOKS";

const useLogics = ({ onPrint, onRefresh, onCreateReturned }) => {
  const { setDrawer } = useContext(DrawerContext);
  const { info } = useContext(AuthContext);
  const canCreateReturnedDelivery = useAuthority("CREATE_RETURNED_DELIVERY");
  const { confirm } = Modal;
  const notRecallableStatues = [
    "NEO",
    "NEO_COLLECT",
    "UNDELIVERED",
    "DELIVERED",
  ];

  const confirmDelete = async ({ customerDeliveryNo, type }) => {
    if (!info.authorities.includes("DELIVERY_DELETE")) {
      return message.error("Gönderi silme yetkiniz bulunmamaktadır!");
    }
    confirm({
      title: "Silmek İstediğinize emin misiniz?",
      icon: <ExclamationCircleOutlined />,
      content:
        "Gönderiyi silmek istediğinizden emin misiniz? Onaylarsanız kalıcı olarak silinecektir. Devam etmek istiyor musunuz?",
      onOk() {
        return new Promise(async (resolve) => {
          //onLoading(true);
          let obj = { customerDeliveryNo: customerDeliveryNo };
          if (type === "RETURNED") {
            obj.type = "RETURNED";
          }
          const response = await deleteDeliveryInOperation(obj);
          if (response && response?.response?.status !== 400) {
            onRefresh();
          } else if (response?.response?.data?.error?.msg) {
            message.error({
              content: response?.response?.data?.error?.msg,
              className: "app-error-message",
              duration: 3,
            });
          }
          //onLoading(false);
          resolve();
        });
      },
      onCancel() {},
    });
  };
  const confirmRecall = async ({ customerDeliveryNo }) => {
    if (!info.authorities.includes("DELIVERY_RECALL")) {
      return message.error(
        "Gönderiyi kargoda iptal etme yetkiniz bulunmamaktadır!"
      );
    }
    confirm({
      title: "Gönderiyi Kargoda İptal Et",
      icon: <ExclamationCircleOutlined />,
      okText: "Evet",
      cancelText: "Hayır",
      okType: "danger",
      content:
        "Gönderiyi iptal etmek istediğinizden emin misiniz? İptal edilen gönderilerin satıcıya iade süreci başlayacaktır. Devam etmek istiyor musunuz?",
      onOk() {
        return new Promise(async (resolve) => {
          //onLoading(true);
          let obj = { customerDeliveryNo: customerDeliveryNo };
          const response = await recallDeliveryInOperation(obj);
          if (response && response?.response?.status !== 400) {
            onRefresh();
          } else if (response?.response?.data?.error?.msg) {
            message.error({
              content: response?.response?.data?.error?.msg,
              className: "app-error-message",
              duration: 3,
            });
          }
          //onLoading(false);
          resolve();
        });
      },
      onCancel() {},
    });
  };

  const menu = (record) => {
    return (
      <Menu>
        <Menu.Item
          key="1"
          icon={<AiOutlineBarcode style={{ marginRight: 5 }} />}
          onClick={(e) => {
            e.domEvent.stopPropagation();
            if (!info.authorities.includes("PRINT_BARCODE")) {
              return message.error("Barkod basma yetkiniz bulunmamaktadır!");
            }
            onPrint([
              {
                customerDeliveryNo: record.delivery.customerDeliveryNo,
                totalParcels: record.delivery.totalParcels,
              },
            ]);
          }}
          disabled={record?.delivery.deliveryType === "RETURNED"}
        >
          Barkod Yazdır
        </Menu.Item>
        {record.delivery.deliveryStatus === "NEO_COLLECT" && (
          <Menu.Item
            key="6"
            danger
            icon={<AiFillDelete style={{ marginRight: 5 }} />}
            onClick={(e) => {
              e.domEvent.stopPropagation();
              confirmDelete({
                customerDeliveryNo: record.delivery.customerDeliveryNo,
              });
            }}
          >
            Gönderiyi Sil
          </Menu.Item>
        )}
        {record.delivery.deliveryType === "RETURNED" &&
          record.delivery.deliveryStatus === "WAITING_FOR_DISPATCH" && (
            <Menu.Item
              key="6"
              danger
              icon={<AiFillDelete style={{ marginRight: 5 }} />}
              onClick={(e) => {
                e.domEvent.stopPropagation();
                confirmDelete({
                  customerDeliveryNo: record.delivery.customerDeliveryNo,
                  type: "RETURNED",
                });
              }}
            >
              Gönderiyi Sil
            </Menu.Item>
          )}
        {record.delivery.deliveryStatus !== "NEO_COLLECT" &&
          record.delivery.deliveryType !== "RETURNED" &&
          record.delivery.deliveryStatus !== "WAITING_FOR_DISPATCH" && (
            <Menu.Item
              style={{ opacity: 0.5 }}
              disabled
              danger
              icon={<AiFillDelete style={{ marginRight: 5 }} />}
            >
              Gönderiyi Sil
            </Menu.Item>
          )}
        {info.canRecall && info.recall && (
          <Menu.Item
            key="7"
            icon={<TbTruckReturn style={{ marginRight: 5 }} />}
            style={
              (notRecallableStatues.includes(record.delivery.deliveryStatus) ||
                record.delivery.deliveryType === "RETURNED") && {
                opacity: 0.5,
              }
            }
            disabled={
              notRecallableStatues.includes(record.delivery.deliveryStatus) ||
              record.delivery.deliveryType === "RETURNED"
            }
            onClick={(e) => {
              e.domEvent.stopPropagation();
              confirmRecall({
                customerDeliveryNo: record.delivery.customerDeliveryNo,
              });
            }}
          >
            <span style={{ color: "green" }}> Kargoda İptal</span>
          </Menu.Item>
        )}
        {canCreateReturnedDelivery && (
          <Menu.Item
            key="8"
            icon={<TbPackageImport style={{ marginRight: 5 }} />}
            onClick={(e) => {
              e.domEvent.stopPropagation();
              onCreateReturned(record);
            }}
            disabled={
              record?.delivery?.deliveryType === "RETURNED" ||
              record?.delivery?.deliveryStatus !== "DELIVERED"
            }
          >
            İade Oluştur
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const isB2BPro = info?.specialTags?.includes("B2BPRO");
  const deliveryPerformances = {
    "delivery on time": "Zamanında Teslim",
    ongoing: "Devam Ediyor",
    "late delivery": "Geç Teslim",
  };
  const b2bProColumns = [
    {
      title: "Gerçekleşen Teslim Tarihi",
      key: "deliveredDate",
      dataIndex: "deliveredDate",
      render: (_, record) =>
        record?.delivery?.deliveredDate
          ? moment(record.delivery.deliveredDate, "DD.MM.YYYY HH:mm:ss")
              .locale("tr")
              .format(Constants.FORMATS.dateTimeFormat)
          : "",
      width: 200,
    },
    {
      title: "Gönderi Oluşturulma Tarihi",
      key: "createdOn",
      dataIndex: "createdOn",
      render: (_, record) =>
        record?.createdOn
          ? moment(record.createdOn)
              .locale("tr")
              .format(Constants.FORMATS.dateTimeFormat)
          : "",
      width: 200,
    },
    {
      title: "Gönderi Kabul Tarihi",
      key: "acceptDate",
      dataIndex: "acceptDate",
      render: (_, record) =>
        record?.acceptDate
          ? moment(record.acceptDate).format(Constants.FORMATS.dateTimeFormat)
          : "",
      width: 200,
    },
    {
      title: "Teslim Performansı Detayı",
      key: "deliveryPerformance",
      dataIndex: "deliveryPerformance",
      render: (_, record) =>
        deliveryPerformances[record?.deliveryPerformance] || "",
      width: 200,
    },
    {
      title: (
        <Tooltip title="Geç Teslimat / Teslim Edememe / Sipariş İptali Nedeni">
          Teslim Edilememe Nedeni
        </Tooltip>
      ),
      key: "nonDeliveryReason",
      dataIndex: "nonDeliveryReason",
      render: (_, record) => record?.delivery?.nonDeliveryReason || "",
      width: 200,
    },
    {
      title: "Rapid İş Emri",
      key: "rapidWorkNumber",
      dataIndex: "rapidWorkNumber",
      render: (_, record) => record?.metadata?.rapidWorkNumber || "",
      width: 200,
    },
    {
      title: "Web Sipariş Numarası",
      key: "webOrderNumber",
      dataIndex: "webOrderNumber",
      render: (_, record) => record?.metadata?.webOrderNumber || "",
      width: 200,
    },
    {
      title: "Müşteri Adı",
      key: "endConsumerName",
      dataIndex: "endConsumerName",
      render: (_, record) => record?.metadata?.endConsumerName || "",
      width: 200,
    },
    {
      title: "İrsaliye Numarası",
      key: "wayBill",
      dataIndex: "wayBill",
      render: (_, record) => record?.metadata?.wayBill || "",
      width: 200,
    },
  ];

  const columns = [
    {
      title: "Barkod",
      key: "customerDeliveryNo",
      dataIndex: "customerDeliveryNo",
      width: 270,
      render: (_, record) => {
        return (
          <div className="big-text-container">
            <div className="big-text">
              <Tooltip title="Gönderi Detayı" placement="top">
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() =>
                    setDrawer({
                      title: `${record?.delivery?.customerDeliveryNo} - Gönderi Detayı`,
                      ...record,
                    })
                  }
                >
                  {record?.delivery?.customerDeliveryNo}
                </Button>
              </Tooltip>
              <CopyElement text={record?.delivery?.customerDeliveryNo} />
            </div>
          </div>
        );
      },
      width: 200,
      fixed: "left",
    },
    {
      title: "Alıcı",
      key: "receiver",
      dataIndex: "receiver",
      render: (_, record) => `${record.receiver.receiver} `,
      width: 200,
    },
    {
      title: "Alıcı Adresi",
      key: "address",
      dataIndex: "address",
      render: (_, record) =>
        `${record.receiver.town} / ${record.receiver.city}`,
      width: 200,
    },
    ...(isB2BPro
      ? [
          {
            title: "Gönderici",
            key: "sender",
            dataIndex: "sender",
            render: (_, record) =>
              `${record.sender?.sender || record?.senderCompanyName || ""} `,
            width: 200,
          },
          {
            title: "Çıkış Adresi",
            key: "senderAddress",
            dataIndex: "senderAddress",
            render: (_, record) =>
              `${
                record.senderTown && record.senderCity
                  ? `${record.senderTown} / ${record.senderCity}`
                  : ""
              } `,
            width: 200,
          },
        ]
      : []),
    {
      title: "Gönderi Durumu",
      key: "deliveryStatus",
      dataIndex: "deliveryStatusText",
      width: 120,
      render: (_, record) => (
        <Tag color="blue" style={{ width: "100%", textAlign: "center" }}>
          {record?.delivery?.deliveryStatusText}
        </Tag>
      ),
    },
    {
      title: "Gönderi Tipi",
      key: "deliveryType",
      dataIndex: "deliveryType",
      width: 200,
      render: (_, record) => {
        return (
          <>
            {record?.delivery?.desi > 41 && (
              <>XL TESLİMAT{record?.product?.productCode && " , "}</>
            )}
            {record?.delivery?.deliveryType === "RETURNED" ? (
              <>RANDEVULU İADE</>
            ) : (
              <>
                {info?.merchantList.length > 0 && (
                  <>{record?.delivery?.deliveryType} , </>
                )}
                {record?.serviceTypes?.includes("POD") && (
                  <>TAHSİLATLI GÖNDERİ{record?.product?.productCode && " , "}</>
                )}
                {record?.product?.productCode === "HX_STD" &&
                  "STANDART TESLİMAT"}
                {record?.product?.productCode === "HX_ND" &&
                  "ERTESİ GÜN TESLİMAT"}
                {record?.product?.productCode === "HX_SD" && "BUGÜN TESLİMAT"}
              </>
            )}
          </>
        );
      },
    },
    {
      title: "Tahmini Teslimat",
      key: "deliveryDatePromised",
      dataIndex: "deliveryDatePromised",
      render: (_, record) => {
        const date =
          record?.delivery?.deliveryDatePromised ||
          record?.delivery?.deliveryDateOriginal;
        if (!date) return "";
        if (isB2BPro) {
          return moment(date, ["DD.MM.YYYY HH:mm:ss", "DD.MM.YYYY"])
            .locale("tr")
            .format(Constants.FORMATS.dateTimeFormat);
        }
        return moment(date, "DD.MM.YYYY").format(Constants.FORMATS.dateFormat);
      },
      width: 200,
    },
    ...(isB2BPro ? b2bProColumns : []),
    {
      title: "İşlemler",
      width: 90,
      fixed: "right",
      render: (_, record) => (
        <Dropdown overlay={menu(record)} placement="bottomRight">
          <Button type="primary" size="small" block>
            <span>
              İşlemler <AiOutlineDown style={{ left: 5 }} />
            </span>
          </Button>
        </Dropdown>
      ),
    },
  ];

  const excelColumns = [];
  const searchKeys = [];
  const scroll = { x: "max-content" };
  const sticky = { offsetHeader: 0, offsetScroll: 0 };
  return { columns, excelColumns, searchKeys, scroll, sticky };
};

export default useLogics;
